import React, { Component } from "react";
import intl from "react-intl-universal";
import LoaderButton from "./LoaderButton";
import DivsPattern from "./skylineDesignPattern";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";

class ContactUs extends Component {
  state = {
    firstName: "",
    email: "",
    companyName: "",
    message: "",
    isLoading: false,
    isCUForm: true
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    console.log(this.state.message);

    fetch(process.env.REACT_APP_API_URL + "SendContactUs", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        Email: this.state.email,
        FirstName: this.state.firstName,
        CompanyName: this.state.companyName,
        Message: this.state.message
      })
    })
      .then(res => res.json())
      .then(result => {
        if (result.Result.toString().toLowerCase() === "success") {
          this.setState({ isCUForm: false });
        }
        this.setState({ isLoading: false });
      })
      .catch(error => {
        console.error(error);
        this.props.props.handleServerError(true);
      });
  };

  renderContactUsForm() {
    return (
      <DivsPattern headerText={intl.get("Contact_Us_Title")}>
        <form className="form-signin" onSubmit={this.handleSubmit}>
          <FormGroup controlId="firstName" className="form-label-group">
            <FormControl
              autoFocus
              value={this.state.firstName}
              onChange={this.handleChange}
              placeholder={intl.get("First_Name")}
              className="form-control"
              required
            />
          </FormGroup>
          <FormGroup controlId="email" className="form-label-group">
            <FormControl
              type="email"
              value={this.state.email}
              placeholder={intl.get("Eamil_Address_Test")}
              onChange={this.handleChange}
              className="form-control"
              required
            />
          </FormGroup>
          <FormGroup controlId="companyName" className="form-label-group">
            <FormControl
              value={this.state.companyName}
              onChange={this.handleChange}
              placeholder={intl.get("Company_Name")}
              className="form-control"
            />
          </FormGroup>
          <FormGroup controlId="message" className="form-label-group">
            <textarea
              value={this.state.message}
              onChange={event => {
                this.setState({ message: event.target.value });
              }}
              rows="7"
              placeholder={intl.get("Contact_Us_Message_PlaceHolder")}
              className="form-control"
            />
          </FormGroup>
          <LoaderButton
            className="btn-lg btn btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2 btn-login"
            type="submit"
            // disabled={!this.validateForm()}
            text={intl.get("Send")}
            isLoading={this.state.isLoading}
            loadingText={intl.get("Sending_An_Email")}
          />
        </form>
      </DivsPattern>
    );
  }

  renderThanksForSending() {
    return (
      <DivsPattern headerText={intl.get("Contact_Us_Title")}>
        <div className="form-label-group">
          <p>{intl.get("Contact_Us_Thanks")}</p>
        </div>
      </DivsPattern>
    );
  }

  render() {
    return this.state.isCUForm
      ? this.renderContactUsForm()
      : this.renderThanksForSending();
  }
}

export default ContactUs;
